import LegalLayout from "@/components/LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout
      title="Privacy Policy — LKTH LTD"
      description="How LKTH LTD collects, uses and protects your personal data, in line with UK GDPR and the Data Protection Act 2018."
      updated="January 2026"
      testid="privacy-policy-page"
    >
      <p>
        LKTH LTD ("we", "us", "our") is committed to protecting your privacy. This policy explains
        what personal data we collect, why we collect it, and the rights you have under the UK
        General Data Protection Regulation (UK GDPR) and the Data Protection Act 2018.
      </p>

      <h2>1. Who we are</h2>
      <p>
        LKTH LTD is a company registered in England &amp; Wales, with its registered office at Unit
        16 Park Village, Norfolk Park Road, Sheffield, South Yorkshire, S2 2UA, United Kingdom. For
        the purposes of UK GDPR, LKTH LTD is the data controller for personal data collected through
        this website. You can contact us at{" "}
        <a href="mailto:Lateshkatravath3366@gmail.com">Lateshkatravath3366@gmail.com</a>.
      </p>

      <h2>2. What data we collect</h2>
      <ul>
        <li><strong>Enquiry data:</strong> your name, email address, phone number, company name, the service you are interested in and the content of your message, when you complete our contact form.</li>
        <li><strong>Communication records:</strong> correspondence when you contact us by phone or email.</li>
        <li><strong>Usage data:</strong> anonymous technical data about your visit (browser type, pages viewed) if you have accepted optional analytics cookies.</li>
      </ul>

      <h2>3. How we use your data</h2>
      <ul>
        <li>To respond to enquiries and provide quotes — <em>lawful basis: legitimate interests / steps prior to entering a contract</em>.</li>
        <li>To deliver and support services you have purchased — <em>lawful basis: contract</em>.</li>
        <li>To improve our website — <em>lawful basis: consent (analytics cookies)</em>.</li>
        <li>To comply with legal obligations — <em>lawful basis: legal obligation</em>.</li>
      </ul>
      <p>We do not use your data for automated decision-making or profiling, and we never sell your personal data.</p>

      <h2>4. Sharing your data</h2>
      <p>
        We share data only with service providers who process it on our behalf (for example, our
        website hosting and email delivery providers), under contracts that require them to protect
        your information. Where providers are located outside the UK, we rely on appropriate
        safeguards such as UK adequacy regulations or standard contractual clauses.
      </p>

      <h2>5. How long we keep your data</h2>
      <p>
        Enquiry records are kept for up to 24 months after our last contact, so we can follow up on
        your request. Client records are kept for the duration of the business relationship and
        thereafter only as required by law (for example, six years for accounting records).
      </p>

      <h2>6. Your rights</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Access the personal data we hold about you;</li>
        <li>Have inaccurate data corrected;</li>
        <li>Have your data erased (in certain circumstances);</li>
        <li>Restrict or object to our processing;</li>
        <li>Receive your data in a portable format;</li>
        <li>Withdraw consent at any time (where processing is based on consent).</li>
      </ul>
      <p>
        To exercise any of these rights, email{" "}
        <a href="mailto:Lateshkatravath3366@gmail.com">Lateshkatravath3366@gmail.com</a>. You also
        have the right to complain to the Information Commissioner's Office (ICO) at{" "}
        <a href="https://ico.org.uk" target="_blank" rel="noopener noreferrer">ico.org.uk</a>.
      </p>

      <h2>7. Security</h2>
      <p>
        We use appropriate technical and organisational measures to protect personal data,
        including encrypted connections (HTTPS/TLS), access controls and secure storage. Where data
        breaches are required to be reported, we will notify the ICO and affected individuals as UK
        GDPR requires.
      </p>

      <h2>8. Changes to this policy</h2>
      <p>
        We may update this policy from time to time. The "last updated" date at the top of this
        page shows when it was last revised.
      </p>
    </LegalLayout>
  );
}
